import { Environment } from './environment.types';
import { filterNavigation } from './navigation';
import productionEnvironment from './environment.production';

const environment: Partial<Environment> = {
  ...productionEnvironment,
  apiBaseUrl: 'https://parasandbox2-qms-api.sierralabs.com/api/',
  navigation: filterNavigation(
    'Dashboard',
    'Training Admin',
    'Risk Management',
    'Documents',
    'Change Order',
    'Products',
    'Hazards',
    'CAPA',
    'SCAR',
    'Supplier Management',
    'Teams',
    'Employees',
    'Forms',
    'Workflow',
    'Task Types'
  ),
  productConfig: {
    userNeed: {
      disableRelations: ['validations', 'verifications'],
      hideRiskField: true
    },
    designInput: {
      disableRelations: ['validations', 'verifications', 'designSpecs'],
      hideRiskField: true
    },
    designOutput: {
      disableRelations: ['validations', 'verifications', 'designSpecs']
    },
    validation: {
      hideTestSteps: true
    },
    verification: {
      hideTestSteps: true
    }
  },
  hazardConfig: { idPrefix: 'HS' },
  riskConfig: {
    hideCategory: true
  },
  changeOrderConfig: {
    useCustomFields: true
  }
};

export default environment;
